import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);
  constructor() { }

  transform(value: string, customClass?: string): SafeHtml {
    if (!value) return '';

    // Common date patterns to match
    const datePatterns = [
      // MM/DD/YYYY or MM/DD/YY
      /\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/g,
      // MM-DD-YYYY or MM-DD-YY
      /\b\d{1,2}-\d{1,2}-\d{2,4}\b/g,
      // YYYY-MM-DD
      /\b\d{4}-\d{1,2}-\d{1,2}\b/g,
      // Month DD, YYYY (with optional ordinal suffixes)
      /\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{1,2}(?:st|nd|rd|th)?,? \d{4}\b/gi,
      // DD Month YYYY (with optional ordinal suffixes)
      /\b\d{1,2}(?:st|nd|rd|th)? (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4}\b/gi,
      // MM/DD/YYYY HH:MM AM/PM
      /\b\d{1,2}\/\d{1,2}\/\d{2,4} \d{1,2}:\d{2} (?:AM|PM)\b/gi,
      // MM-DD-YYYY HH:MM AM/PM
      /\b\d{1,2}-\d{1,2}-\d{2,4} \d{1,2}:\d{2} (?:AM|PM)\b/gi
    ];

    let result = value;

    //default to bold
    datePatterns.forEach(pattern => {
      result = result.replace(pattern, (match) => {
        if (customClass) {
          return `<span class="${customClass}">${match}</span>`;
        } else {
          return `<strong>${match}</strong>`;
        }
      });
    });

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  static toDate(dateInput?: string | Date | null): Date | null {
    if (!dateInput) return null;
    if (dateInput instanceof Date) return dateInput;

    // Parse date string (YYYY-MM-DD format) as local time to avoid timezone shifts
    if (typeof dateInput === 'string') {
      const parts = dateInput.split('T')[0].split('-');
      if (parts.length === 3) {
        const [year, month, day] = parts.map(p => Number.parseInt(p, 10));
        const d = new Date(year, month - 1, day);
        return Number.isNaN(d.getTime()) ? null : d;
      }
    }

    const d = new Date(dateInput);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static formatDateToString(dateInput: any): string {
    if (dateInput instanceof Date) {
      return dateInput.toISOString().split('T')[0];
    }
    return typeof dateInput === 'string' ? dateInput : '';
  }
} 